import React from 'react';

interface Props {
	text: string;
	backGroundColor?: string;
	fontFamily?: string;
	buttonColorText: string;
	buttonRadius?: number;
}

export const WidgetButton = (props: Props): React.ReactElement => {
	const { text, backGroundColor, fontFamily, buttonColorText, buttonRadius } = props;

	return (
		<button
			className="ui-widget-ok-button"
			type="submit"
			style={{
				background: `${backGroundColor}`,
				fontFamily: `${fontFamily}`,
				color: `${buttonColorText}`,
				borderRadius: `${buttonRadius}px`
			}}
		>
			{text}
		</button>
	);
};
